import CategoriesBlock from './CategoriesBlock';
import ContactBlock from './ContactBlock';
import HeroBlock from './HeroBlock';
import IngredientBlock from './IngredientBlock';
import ProductRailBlock from './ProductRailBlock';
import RoutineBlock from './RoutineBlock';
import StoryBlock from './StoryBlock';

/** Home block type -> component. Unknown types are skipped (newer server, older build). */
export const BLOCKS = {
  hero: HeroBlock,
  categories: CategoriesBlock,
  productRail: ProductRailBlock,
  routine: RoutineBlock,
  ingredient: IngredientBlock,
  story: StoryBlock,
  contact: ContactBlock,
};

export { HeroSkeleton } from './HeroBlock';
